import React, { useMemo } from 'react'
import { Container, StyledColumn } from './styles'
import { useSelector } from 'react-redux'

import image1 from '@/assets/images/landingPage/Img1.png'
import image2 from '@/assets/images/landingPage/Img2.png'
import image3 from '@/assets/images/landingPage/Img3.png'
import image4 from '@/assets/images/landingPage/Img4.png'
import image5 from '@/assets/images/landingPage/Img5.png'
import image6 from '@/assets/images/landingPage/Img6.png'
import image7 from '@/assets/images/landingPage/Img7.png'
import image8 from '@/assets/images/landingPage/Img8.png'
import confectionery_image1 from '@/assets/images/landingPage/Confectionery1.png'
import confectionery_image2 from '@/assets/images/landingPage/Confectionery2.png'
import confectionery_image3 from '@/assets/images/landingPage/Confectionery3.png'
import confectionery_image4 from '@/assets/images/landingPage/Confectionery4.png'
import confectionery_image5 from '@/assets/images/landingPage/Confectionery5.png'
import confectionery_image6 from '@/assets/images/landingPage/Confectionery6.png'
import confectionery_image7 from '@/assets/images/landingPage/Confectionery7.png'
import confectionery_image8 from '@/assets/images/landingPage/Confectionery8.png'

const ImageGroup = () => {
  const { theme } = useSelector(state => state.survey)
  const isConfectionery = useMemo(() => theme === 'Confectionery', [theme])
  const images = isConfectionery
    ? [
        confectionery_image1,
        confectionery_image2,
        confectionery_image3,
        confectionery_image4,
        confectionery_image5,
        confectionery_image6,
        confectionery_image7,
        confectionery_image8
      ]
    : [image1, image2, image3, image4, image5, image6, image7, image8]

  return (
    <Container>
      {images.map((image, index) => (
        <StyledColumn image={image} key={index}></StyledColumn>
      ))}
    </Container>
  )
}
export default ImageGroup
